const d = {
    CustomEvent: "ce",
    Pr: "p",
    wc: "pc",
    Ac: "ca",
    Su: "i",
    qu: "ie",
    ts: "cci",
    rs: "ccic",
    Mt: "ccc",
    Wt: "ccd",
    Fl: "ss",
    Dl: "se",
    Ki: "si",
    Li: "sc",
    Qi: "sbc",
    Mc: "sfe",
    Do: "iec",
    bc: "lr",
    vc: "uae",
    ss: "ci",
    Ot: "cc",
    Sc: "lcaa",
    yc: "lcar",
    Hn: "inc",
    On: "add",
    Gn: "rem",
    $n: "set",
    Bn: "ncam",
    jc: "sgu",
    yr: "ffi",
    ro: "bi",
    ct: "bc",
  },
  dr = { Fr: "feed_displayed", Dc: "content_cards_displayed" };
export { d as EventTypes, dr as InternalEventTypes };
